


























import { Component, Vue } from "vue-property-decorator";
import Modal from "@/shared/components/modal.vue";
import { required } from "@/shared/validators";
import { ConsultoresService } from "@/services/consultores.service";

@Component({
  components: {
    Modal,
  },
})
export default class CancelarPlano extends Vue {
  idPlano: number | null = null;
  idConsultor!: number;
  motivo: string | null = null;
  valid = false;
  loading = false;

  rules = {
    motivo: [required()],
  };

  get tituloManter(): string {
    return "Cancelar plano";
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async cancelamentoPlano(idConsultor: number, idPlano: number) {
    const modal = this.$refs.modal as Modal;
    const p = modal.open();
    this.idPlano = idPlano;
    this.idConsultor = idConsultor;
    return p;
  }

  async cancelaPlano() {
    const modal = this.$refs.modal as Modal;
    const form = this.$refs.form as any;

    if (form.validate()) {
      this.loading = true;
      await ConsultoresService.CancelarPlano(
        this.idConsultor,
        this.idPlano!,
        this.motivo!
      );
      this.loading = false;
      return modal.close(true);
    }
  }
}
